import { Leap4Breadcrumbs, TimeNavbarPicker, Grid } from "@leap4/frontend";
import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { IDateRangeGState } from "../../../../interfaces/datesGlobalState.interface";
import { RootState } from "../../../../interfaces/root-state.interface";
import { setDatesRange } from "../../../../store/actions/dateRange.actions";

const mapStateToProps = (state: RootState) => ({
    dates: state.dates,
});

const mapActions = {
    setDatesRange
}

const connector = connect(mapStateToProps, mapActions);

type PropsFromRedux = ConnectedProps<typeof connector>;

interface IReportHeaderProps extends PropsFromRedux {
    breadcrumbsIcon?: JSX.Element
    breadcrumbs: {
        text: string
        link?: string,
        icon?: React.ReactElement
    }[]
    setDatesRange: (startDate: string, endDate: string) => void,
    dates: IDateRangeGState,
    hideTimeNavbar?: boolean,
}

const ReportHeader = (props: IReportHeaderProps): JSX.Element => {

    const { breadcrumbs, dates, setDatesRange, hideTimeNavbar } = props;

    const { startDate, endDate, isLoadingAny } = dates

    return (
        <>
            {!hideTimeNavbar && (
                <Grid item sm={12} p={2}>
                    <TimeNavbarPicker
                        isLoading={isLoadingAny}
                        setDates={setDatesRange}
                        excludeTabs={[]}
                        dates={{ startDate, endDate }} />
                </Grid>
            )}
            <Grid item sm={12} style={{ marginTop: "2vh" }} className={"test"}>
                <Grid container justifyContent={"space-between"} alignItems="center">
                    <Grid item>
                        <Leap4Breadcrumbs breadcrumbs={breadcrumbs} />
                    </Grid>

                </Grid>
            </Grid>
        </>
    )
}

export default connector(ReportHeader)